export const contentTableConfig = {
  title: '企业主体列表',
  propList: [
    { prop: 'name', label: '主体名称', minWidth: '150', align: 'left' },
    { prop: 'corPid', label: '主体ID', minWidth: '150' },
    { prop: 'total', label: '留痕总数', minWidth: '150' },
    { prop: 'used', label: '已使用', minWidth: '150' },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ]
}
